import React from 'react'
import TryButton from './TryButton'
import { ImageTextItemInterface } from '@/types/newTypes'

const OurTechnologies = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const items: ImageTextItemInterface[] = [
    {
      img: '/img/our-technologies/1.png',
      text: 'AI-Powered Photo Recognition',
    },
    {
      img: '/img/our-technologies/2.png',
      text: 'Smart Algorithms for Optimal Space Saving',
    },
    {
      img: '/img/our-technologies/3.png',
      text: 'Secure Photo Management',
    },
  ]
  return (
    <section className="flex flex-col gap-6 mb-14 relative before:absolute before:w-[375px] before:h-[375px] before:-top-[50px] before:left-0 before:bg-[left_center] before:bg-whatYouGetBg before:-z-[1] before:bg-no-repeat">
      <h2 className="text-center px-4 text-XL font-bold">Our technologies</h2>
      <div className="flex flex-col gap-3 max-w-standard mx-auto w-full">
        {items.map((item, index) => (
          <figure
            key={index}
            className="flex flex-row gap-4 items-center py-3 px-4 bg-white/15 rounded-2.5xl"
          >
            <img src={item.img} alt={item.text} className="max-w-10" />
            <figcaption className="text-logo font-semibold">{item.text}</figcaption>
          </figure>
        ))}
      </div>
      <div className="max-w-standard mx-auto w-full">
        <TryButton to={isWhitePage ? '/email' : '/scan-results'} />
      </div>
    </section>
  )
}

export default OurTechnologies
